export default function WhatIsNot() {
  const limitations = [
    {
      icon: 'ri-close-circle-line',
      text: '不是完整多頁官網'
    },
    {
      icon: 'ri-close-circle-line',
      text: '不包含SEO深度優化'
    },
    {
      icon: 'ri-close-circle-line',
      text: '不提供原始碼交付'
    },
    {
      icon: 'ri-close-circle-line',
      text: '不接受反覆客製修改'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            這不是什麼？
          </h2>
          <p className="text-lg text-gray-600">為了避免誤會，我們先說清楚</p>
          <div className="w-20 h-1 bg-teal-500 mx-auto mt-6"></div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 md:p-14 shadow-sm border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            {limitations.map((item, index) => (
              <div 
                key={index}
                className="flex items-start p-5 bg-white rounded-lg border border-gray-200"
              >
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-xl text-red-600`}></i>
                </div>
                <span className="ml-4 text-base text-gray-700 font-medium mt-2">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="bg-teal-50 rounded-xl p-6 border-l-4 border-teal-500">
            <div className="flex items-start">
              <i className="ri-lightbulb-line text-teal-600 text-2xl mr-3 mt-1 flex-shrink-0"></i>
              <div>
                <p className="text-lg text-gray-800 leading-relaxed">
                  <i className="ri-arrow-right-line text-teal-600 mr-2"></i>
                  這一頁的定位是<strong className="text-teal-700">「起步入口（MVP）」</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
